<template>
  <el-container>
    <el-aside width="46px" :class="{asidewidth:showbigmenu}">
      <div class="content">
        <transition name="el-zoom-in-top">
          <div class="left-menu l" :class="{wide:showbigmenu}">
            <div class="top-name">
              <span class="name-txt l">{{topmenuname}}</span>
              <i class="icon-triggle l" @click="ChangeMenuShowType()"></i>
            </div>
            <!-- 菜单容器 -->
            <div class="left-menu-wrap" tabindex="1" style="overflow: hidden; outline: none;">
              <ul class="left-menu-list">
                <li class="left-menu-item top-item sub-item" v-bind:class="{open:showmenucode==secondmenu.menucode}"
                    v-for="secondmenu in menulist"
                    v-on:mouseover="ShowChildHTML(true,secondmenu)" v-on:mouseout="ShowChildHTML(false,secondmenu)">
                  <a href="javascript:void(0);" class="item-link"
                     v-bind:class="{NowSelMenu:selCode==secondmenu.menucode}" style="padding-left: 13px;"
                     :title="secondmenu.menuname" @click="RouterSecondMenu(secondmenu)">
                    <i class="left-menu-icon" :class="secondmenu.bigicon"></i><span class="item-link-text">{{secondmenu.menuname}}</span>
                    <i class="menu-trigger" v-if="secondmenu.childmenu.length > 0"></i>
                  </a>
                  <div class="slide-second-menu" v-if="secondmenu.childmenu.length > 0"><span class="slide-second-span">{{secondmenu.menuname}}</span>
                  </div>
                  <ul class="left-menu-sub" v-if="secondmenu.childmenu.length > 0" :class="{fullheight:!showbigmenu}"
                      v-show="showmenucode==secondmenu.menucode">
                    <li class="left-menu-item " v-for="threemenu in secondmenu.childmenu">
                      <a href="javascript:void(0);" class="item-link"
                         v-bind:class="{itemlinkonclick:threemenucode==threemenu.menucode}"
                         @click="RouterThreeMenu(threemenu,secondmenu)" style="padding-left: 45px;">
                        <i class="left-menu-dot"></i><span class="item-link-text">{{threemenu.menuname}}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </el-aside>
    <el-main>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </el-main>
  </el-container>
</template>
<script>
  import {getMenu} from '@/api/login'

  export default {
    data() {
      return {
        selCode: '',//当前选中的菜单
        topmenuname: this.$route.params.menuname,
        topmenucode: this.$route.params.menucode,
        showmenucode: '',
        threemenucode: '',
        showbigmenu: true,
        menulist: [],
      }
    },

    methods: {

      ChangeMenuShowType() {
        this.showmenucode = this.selCode;
        this.showbigmenu = !this.showbigmenu;
        localStorage.setItem("hpshowbigmenu", this.showbigmenu ? "big" : "small");
      },
      MenuList() {//加载一级菜单
        getMenu({MenuCode: this.topmenucode, AppGuid: (localStorage.getItem("appguid") || "")}).then(response => {
          var ml = response.data.menu;
          //默认第一个
          this.showmenucode = ml[0].menucode;
          if (ml[0].childmenu.length > 0) {
            this.RouterThreeMenu(ml[0].childmenu[0], ml[0]);
          } else {
            this.RouterPush(ml[0]);
          }

          if (!this.showbigmenu)
            this.showmenucode = '';
          this.menulist = ml;
        }).catch((error) => {
          console.log(error)
        });
      },
      ShowChildHTML(ifShow, row) {
        if (!this.showbigmenu) {
          if (ifShow)
            this.showmenucode = row.menucode;
          else
            this.showmenucode = '';
        }
      },
      RouterSecondMenu(row) {
        this.showmenucode = row.menucode;
        if (row.childmenu.length == 0) {
          this.RouterPush(row);
        }
      },
      RouterThreeMenu(row, rowParent) {
        this.showmenucode = rowParent.menucode;
        this.threemenucode = row.menucode;
        this.RouterPush(row);

      },
      RouterPush(row) {
        this.selCode = this.showmenucode;
        if (this.$route.name !== row.menuurl) {
          this.$router.push({name: row.menuurl});
        }
      }
    },
    mounted() {
      var loaclSto = localStorage.getItem("hpshowbigmenu");
      if (loaclSto != undefined)
        this.showbigmenu = loaclSto == "big";
      this.MenuList();
    }
  }
</script>


<style scoped>
  .el-main {
    padding: 8px;
    padding-bottom: 0px;
    height: calc(100vh - 48px);
    /*background-color: red;*/
    width: 100%;
    overflow: auto;
  }

  .content {
    position: absolute;
    top: 48px;
    bottom: 0;
  }

  .l {
    float: left;
  }

  .asidewidth {
    width: 200px !important;
  }

  /*左侧菜单*/

  .top-name {
    /*position : fixed;
    z-index : 1;*/
    background-color: #2590eb;
    height: 36px;
    text-align: left;
  }

  /*保证侧边展开后侧边滚动不受左边二级菜单滚动影响*/

  .left-menu {
    position: static;
    /*position : static ! important;*/
    height: calc(100vh - 48px);
    /*-webkit-transition: all .6s cubic-bezier(.25, .46, .45, .94);
    transition: all .6s cubic-bezier(.25, .46, .45, .94);*/
    background: #51a6ef;
    width: 46px;
  }

  /*保证正常展开有滚动条*/

  .left-menu.wide {
    position: relative;
    width: 200px;
  }

  .left-menu.noleft {
    display: none;
  }

  .left-menu.wide .menu-trigger {
    display: block;
  }

  .left-menu.wide .icon-trigge {
    background: url('../../assets/images/inside.png') center center no-repeat;
    background-color: #2590eb;
  }

  .name-txt {
    display: none;

    width: 142px;
    height: 36px;
    padding-left: 12px;

    font-size: 14px;
    line-height: 36px;

    cursor: default;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    color: #fff;
  }

  .left-menu.wide .name-txt {
    display: block;
  }

  .icon-triggle {
    display: block;

    width: 46px;
    height: 36px;

    cursor: pointer;

    background: url('../../assets/images/outside.png') center center no-repeat;
    background-color: #2590eb;
  }

  .left-menu.wide .icon-triggle {
    background: url('../../assets/images/inside.png') 24px center no-repeat;
  }

  .left-menu-sub {
  }

  .left-menu-item.open > .left-menu-sub {
    display: block;
    overflow: auto;
  }

  .wide .top-item.open > .slide-second-menu {
    display: none;
  }

  .top-item.open > .slide-second-menu {
    position: absolute;
    z-index: 10;
    top: 0px;
    left: 46px;

    display: block;

    width: 130px;
    height: 36px;
    padding: 0 15px;

    background: #62b1f5;
  }

  .slide-second-span {
    display: block;

    width: 127px;
    height: 35px;
    padding-left: 3px;

    font-size: 14px;
    line-height: 35px;

    text-align: left;

    color: #fff;
    border-bottom: 1px solid #74bcfa;
  }

  .top-item > .left-menu-sub {
    position: absolute;
    z-index: 9999999999;
    top: 36px;
    bottom: 0;
    left: 46px;
    width: 160px;
    background: #62b1f5;
  }

  .fullheight {
    height: calc(100vh - 91px);
  }

  .wide .top-item > .left-menu-sub {
    position: static;
    width: 100%;
    background: transparent;
  }

  .item-link {
    position: relative;

    display: block;

    height: 36px;
    margin-left: -26px;
    /*-webkit-transition: background .3s cubic-bezier(.04, .72, 1, 1);
            transition: background .3s cubic-bezier(.04, .72, 1, 1);*/
    padding-right: 10px;

    line-height: 36px;

    color: #fff;
  }

  .left-menu-item.sub-item > .item-link {
    padding-right: 20px;
  }

  .left-menu.wide .item-link,
  .left-menu-item.top-item > .item-link {
    margin-left: 0;
  }

  .item-link-text {
    display: none;
    overflow: hidden;
    text-align: left;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .wide .item-link-text {
    display: block;
  }

  .open .left-menu-sub .item-link-text {
    display: block;
  }

  .left-menu-icon {
    float: left;

    width: 20px;
    height: 20px;
    margin-top: 0px;
    margin-right: 12px;

    font-size: 20px;
  }

  .menu-trigger {
    position: absolute;
    top: 0;
    right: 0;

    display: none;

    width: 16px;
    height: 100%;
    margin: 0 3px;

    background: url('../../assets/images/icon-out.png') center center no-repeat;
  }

  .wide .menu-trigger {
    display: block;
  }

  .left-menu-sub .menu-trigger {
    display: block;
  }

  .left-menu > .left-menu-wrap {
    height: 96%;
    height: calc(100% - 36px);
  }

  .left-menu.wide > .left-menu-wrap {
    position: absolute;
    top: 36px;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .left-menu.wide .top-item > .item-link > .item-link-text {
    display: block;
  }

  .slide-second-menu {
    display: none;
  }

  .left-menu-dot:before {
    float: left;

    width: 10px;
    height: 36px;

    content: '▪';
  }

  .top-item > .item-link > .left-menu-dot {
    display: none;
  }

  .NowSelMenu,
  .top-item.open > .item-link,
  .top-item.active > .item-link {
    color: #2586d9;
    background: #cfe6fb;
  }

  .itemlinkonclick, .item-link:hover {
    background: #74bbf8;
  }

  .open > .item-link > .menu-trigger {
    background-image: url('../../assets/images/icon-down.png');
  }

  .top-item.open > .item-link > .menu-trigger {
    background-image: url('../../assets/images/slide-down.png');
  }
</style>



// WEBPACK FOOTER //
// src/components/index/SecondMenu.vue